module.exports = require("core-js-pure/stable/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js
// module id = 2845
// module chunks = 25